import { styled } from '@mui/material/styles';
import { keyframes } from '@mui/system';
import { TURN_STYLES } from '@/styles/theme';
import { TurnLogoTrimmed } from '@/svgs';

export const Container = styled('div')(({ theme }) => ({
  position: 'fixed',
  left: '0',
  top: '0',
  height: '100vh',
  width: '100vw',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: theme.palette.mode === 'dark' ? 'rgba(27, 28, 48, 0.7)' : 'rgba(255, 255, 255, 0.8)',
  zIndex: '99999',
}));

export const Wrapper = styled('div')({
  margin: '100px auto',
  width: '50px',
  height: '65px',
  textAlign: 'center',
  fontSize: '10px',
});

const spinner = keyframes`
  0% {
    transform: rotateY(0deg);
  }

  50% {
    transform: rotateY(-360deg);
  }

  100% {
    transform: rotateY(-360deg);
  }
`;

export const Logo = styled(TurnLogoTrimmed)({
  width: '100%',
  height: '100%',
  fill: TURN_STYLES.primaryAccentColor,

  animation: `${spinner} 3s ease-in-out infinite`,
});
